import { VideoModel } from './video.model';
import  normalize from 'json-api-normalize';
import { DrupalBaseModel } from './drupal-base.model';

export class VideoSeriesModel extends DrupalBaseModel {

  public static reorderVideos(data, title) {
    let relatedVideos;
    let index = -1;
    title = title.split('?')[0]; // remove UTM parameters if its present
    data.map( (video: any, foundIndex) => {
      if (video.attributes.path.includes(title)  ) {
          index = foundIndex;
      }
    });
    relatedVideos = data[index];
    data.splice(index, 1);
    data.splice(0, 0, relatedVideos);
    return data;
  }

  public static parseVideoSeries(videoSeriesJson: any, pathArray, videoType?: string): VideoSeriesModel[] {
    const data = normalize(videoSeriesJson).get([
      'title',
      'name',
      'thumbnail',
      'field_video',
      'path',
      'field_short_description',
      'drupal_internal__nid',
      'field_media_oembed_video',
      'id'
    ]);

    // Find the requested video in the list and reorder to the top of the array.
    if (videoType === 'single') {
      data.field_video.dataset.data = this.reorderVideos(data.field_video.dataset.data, pathArray[4]);
    }

    return Array.isArray(data) ? data.map(video => new VideoSeriesModel({
      title: videoType === 'tours' ? video.name : video.title,
      videos: videoType === 'tours' ? VideoModel.parseVideo(video.thumbnail.dataset, '', videoType) as VideoModel[] : VideoModel.parseVideo(video.field_video.dataset) as VideoModel[],
      cmsPath: video.path,
      nid: videoType === 'tours' ? video.id : video.drupal_internal__nid
    })) : [new VideoSeriesModel({
      title: videoType === 'tours' ? data.name : data.title,
      videos: videoType === 'tours' ? VideoModel.parseVideo(data, [], videoType) as VideoModel[] : VideoModel.parseVideo(data.field_video.dataset) as VideoModel[],
      cmsPath: data.path,
      nid: videoType === 'tours' ? data.id : data.drupal_internal__nid
    })];
  }

  public title: string;
  public videos: VideoModel[] = [];

  constructor(values?: Partial<VideoSeriesModel> ) {
    super(values);
    Object.assign(this, values);
  }
}
